import { Heading } from '@chakra-ui/react';
import { APP_VERSION } from '../version'

const VersionInfo: React.FC = () => (
  <Heading size="0xl" mb={0} textAlign="center">
    ({APP_VERSION})
  </Heading>
);

export default VersionInfo;
